import { create_api } from './base';

export default class AuthRepo {
  constructor() {
    this.api = create_api(import.meta.env.REACT_APP_API_ROOT);
  }

  getUser = (config) => this.api.get(`/me`, {}, config);
}
